import React, { useState } from 'react';
import InvoiceDocumentModal from './InvoiceDocumentModal';

const InvoiceNumberCell = ({ invoiceNumber }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleClick = (e) => {
    e.stopPropagation();
    if (invoiceNumber) {
      setModalOpen(true);
    }
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  if (!invoiceNumber) {
    return <span>-</span>;
  }

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          color: '#367c2b',
          textDecoration: 'none',
          cursor: 'pointer',
          fontWeight: 500,
        }}
        onMouseEnter={(e) => (e.target.style.textDecoration = 'underline')}
        onMouseLeave={(e) => (e.target.style.textDecoration = 'none')}
      >
        {invoiceNumber}
      </button>
      <InvoiceDocumentModal 
        open={modalOpen}
        onClose={handleClose}
        invoiceNumber={invoiceNumber}
      />
    </>
  );
};

export default InvoiceNumberCell;
